export var BackgroundType;
(function(BackgroundType) {
    BackgroundType["NONE"] = 'none';
    BackgroundType["SOLID"] = 'solid';
    BackgroundType["GRADIENT"] = 'gradient';
    BackgroundType["PATTERN"] = 'pattern';
    BackgroundType["IMAGE"] = 'image';
})(BackgroundType || (BackgroundType = {}));
export var BackgroundImageDisplayMode;
(function(BackgroundImageDisplayMode) {
    BackgroundImageDisplayMode["TILE"] = 'tile';
    BackgroundImageDisplayMode["COVER"] = 'cover';
    BackgroundImageDisplayMode["CONTAIN"] = 'contain';
})(BackgroundImageDisplayMode || (BackgroundImageDisplayMode = {}));
